<section class="admin-consultations">
  <header class="head">
    <h1>Consultations</h1>
    <button class="refresh" (click)="load()" [disabled]="isLoading()">↻ Refresh</button>
  </header>

  <div class="filters">
    <button *ngFor="let s of statusFilters"
            class="chip"
            [class.active]="activeStatus() === s"
            (click)="setStatus(s)">
      {{ s || 'ALL' }}
    </button>
  </div>

  <div *ngIf="isLoading()" class="state">Loading…</div>

  <div *ngIf="!isLoading() && bookings().length === 0" class="state">
    No bookings for this filter.
  </div>

  <div class="table-wrap" *ngIf="!isLoading() && bookings().length > 0">
    <table class="grid">
      <thead>
        <tr>
          <th>User</th>
          <th>Slot</th>
          <th>Payment</th>
          <th>Booking</th>
          <th class="actions-col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let b of bookings()" [class.busy]="busyId() === b.id">
          <td>
            <div class="user-name">{{ b.userFullName }}</div>
            <div class="user-mail">{{ b.userEmail }}</div>
          </td>
          <td>
            <div>{{ b.slotStartAt | date:'EEE d MMM' }}</div>
            <div class="muted">{{ b.slotStartAt | date:'HH:mm' }} – {{ b.slotEndAt | date:'HH:mm' }}</div>
          </td>
          <td>
            <span class="badge" [ngClass]="'pay-' + (b.paymentStatus || 'none')">
              {{ b.paymentStatus || '—' }}
            </span>
          </td>
          <td>
            <span class="badge" [ngClass]="'st-' + b.status">{{ b.status }}</span>
          </td>
          <td class="actions-col">
            <div class="actions">
              <button class="act primary" *ngIf="canConfirmMeeting(b)"
                      [disabled]="busyId() === b.id" (click)="confirmMeeting(b)">Confirm meeting</button>
              <button class="act" *ngIf="canReschedule(b)"
                      [disabled]="busyId() === b.id" (click)="reschedule(b)">Reschedule</button>
              <button class="act success" *ngIf="canComplete(b)"
                      [disabled]="busyId() === b.id" (click)="complete(b)">Mark done</button>
              <button class="act ghost-danger" *ngIf="canCancel(b)"
                      [disabled]="busyId() === b.id" (click)="cancel(b)">Cancel</button>
              <button class="act" *ngIf="canValidatePayment(b)"
                      [disabled]="busyId() === b.id" (click)="confirmPayment(b)">Confirm payment</button>
              <button class="act ghost-danger" *ngIf="canValidatePayment(b)"
                      [disabled]="busyId() === b.id" (click)="rejectPayment(b)">Reject payment</button>
              <a class="act link" *ngIf="b.meetingLink" [href]="b.meetingLink" target="_blank" rel="noopener">Meeting ↗</a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
